module.exports = __webpack_public_path__ + "static/media/NewsVues Full Logo White.1aec243a.png";